import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import './global.scss';

import FeatureFlagsProvider from './FeatureFlagsProvider';
import PassportRoutes from './Routes';
import ApiProvider from './ApiProvider';
import LoadLocalResources from './LoadLocalResources';
import './datadog';

const isDev = process.env.NODE_ENV !== 'production';

/** Top level application component. */
const App = () => (
  <BrowserRouter basename={process.env.PUBLIC_URL || '/'}>
    {isDev ? <LoadLocalResources /> : null}
    <ApiProvider>
      <FeatureFlagsProvider>
        <PassportRoutes />
      </FeatureFlagsProvider>
    </ApiProvider>
  </BrowserRouter>
);
export default App;
